export const BILLING_TYPE = {
	PREPAID: 'prepaid',
	POSTPAID: 'postpaid',
	TRIAL: 'trial',
	MANUAL: 'manual',
} as const;

export type BillingType = (typeof BILLING_TYPE)[keyof typeof BILLING_TYPE];
